<template lang="html">
  <main class="container">
  	<div class="row">
  		<div class="col-12 white-box no-pad-both-xs" style="max-height: inherit; padding-bottom: 80px;">

  			<div class="col-12" v-if="action == 'rute'">

					<h3>Sådan får du vist vej i Odense Rundt på din hjemmeside</h3>
					<p>Har du en ’Sådan finder du vej til os’-side på din hjemmeside, kan du iframe et kort fra Odense Rundt på din hjemmeside, med link til rutevejledning.</p>

					<strong>Sådan gør du</strong><br>
					<p>
            I html-koden på den side, hvor du vil have vist vej til et sted, indsætter du:<br>
						Dette link, hvis du ønsker at der automatisk vises vej fra brugerens position til bestemmelsesstedet:
					</p>

					<pre>
						<code>
 &lt;iframe style="height: <span class="green">HØJDE</span>px;width: <span class="purple">BREDDE</span>%;" src="https://apps.odenserundt.dk/odenserundtiframe#directions/<span class="pink">KOORDINATER / ADRESSE</span>"&gt;&lt;/iframe&gt;
						</code>
					</pre>

					<p>Dette link, hvis du ønsker at det blot er bestemmelsesstedet, der er plottet ind på kortet:</p>

					<pre>
						<code>
 &lt;iframe style="height: <span class="green">HØJDE</span>px;width: <span class="purple">BREDDE</span>%;" src="https://apps.odenserundt.dk/odenserundtiframe#directions/<span class="pink">KOORDINATER / ADRESSE</span>/false"&gt;&lt;/iframe&gt;
						</code>
					</pre>

					<strong>Du skal rette</strong>
					<ul>
						<li><span class="pink">KOORDINATER / ADRESSE:</span> Slutpunktets koordinater. Koordinaterne skal skrives LÆNGDE,BREDDE. Ønskede koordinater kan findes <a href="https://apps.odenserundt.dk/findkoordinater" target="_blank" class="blue-text underline">her</a>.
							Du kan også skrive en adresse i stedet. Adressen skal skrives: Vejnavn Husnummer, f.eks. Nørregade 36. Indeholder dit husnummer et bogstav, f.eks. Albani Torv 2B, skal bogstavet skrives med stort.
						</li>
						<li><span class="green">HØJDE:</span> Højden på iframen defineret i pixel eller procent. Talværdien skal have ‘px’ eller ‘%’ bagpå. Anbefalet højde er minimum 500px</li>
						<li><span class="purple">BREDDE:</span> Bredden på iframen defineret i pixel eller procent. Talværdien skal have ‘px’ eller ‘%’ bagpå. Anbefalet bredde er 100%</li>
					</ul>
          <br>
					<p>Eksempel på en iframet kortvisning kode med slutpunktet Nørregade 36 med koordinater.</p>
					<pre>
						<code>
 &lt;iframe style="height: 500px;width: 100%;" src="https://apps.odenserundt.dk/odenserundtiframe#directions/55.398535,10.387601"&gt;&lt;/iframe&gt;
						</code>
					</pre>
          <br>
					<p>Eksempel på en iframet kortvisning kode med slutpunktet Nørregade 36 med adresse.</p>

					<pre>
						<code>
 &lt;iframe style="height: 500px;width: 100%;" src="https://apps.odenserundt.dk/odenserundtiframe#directions/nørregade 36"&gt;&lt;/iframe&gt;
						</code>
					</pre>

					<p>Begge eksempler giver følgende resultat.</p>
          <div id="route-iframe-example">
            <iframe title="Iframe rutevisning eksempel" style="height: 500px; width: 100%;" src="https://apps.odenserundt.dk/odenserundtiframe#directions/55.398535,10.387601"></iframe>
          </div>
  			</div>

  			<!-- Oversigt -->
  			<div class="col-12" v-if="action == 'oversigt'">
  				<h3>Sådan får du vist et overblik over steder i Odense Rundt på din hjemmeside</h3>
  				<p>Handler din hjemmeside om noget, der findes flere steder rundt om i Odense, kan du få vist overblik over stederne ved at iframe kortet med stederne fra Odense Rundt på din hjemmeside</p>

					<strong>Sådan gør du</strong><br>
					<span>
						I html-koden på den side, hvor du vil have vist overblik over stederne, indsætter du dette link:
					</span>

					<pre>
						<code>
 &lt;iframe style="height: <span class="green">HØJDE</span>px;width: <span class="purple">BREDDE</span>%; border: <span class="blue">1px solid #565656;</span>" src="https://apps.odenserundt.dk/odenserundtiframe/#tag/<span class="pink">EMNE nummer</span>/<span class="pink">FILTRERING</span>/<span class="light-green">CENTERPUNKT</span>/<span class="yellow">ZOOMNIVEAU</span>"&gt;&lt;/iframe&gt;
						</code>
					</pre>

					<strong>Du skal rette</strong>
					<ul>
  					<li><span class="pink">EMNE nummer(Obligatorisk):</span> Nummeret på det, du ønsker vise. Du finder nummeret sidst i URL’en på Odense Rundt – Playspots har fx nummeret 69:<br>
  						<img src="@/assets/img/tagid.jpg" alt="Billede eksempel af hvordan tag værdi findes">
  					</li>
  					<li><span class="green">HØJDE:</span> Højden på iframen defineret i pixel eller procent. Talværdien skal have ‘px’ eller ‘%’ bagpå. Anbefalet højde er minimum 500px</li>
  					<li><span class="purple">BREDDE:</span> Bredden på iframen defineret i pixel eller procent. Talværdien skal have ‘px’ eller ‘%’ bagpå. Anbefalet bredde er 100%</li>
  					<li><span class="blue">BORDER:</span> Kanten rundt på iframen. Tykkelsen ændres ved at ændre det første tal. Farven kan ændres ved at ændre den sidste værdi (#565656). Farven skal defineres i enten hex eller RGB. Ønskes der ingen kant, erstattets værdien "1px" med "none"</li>
  					<li><span class="pink">FILTRERING(Obligatorisk):</span> På emner, der omhandler trafikale ændringer, kan du vælge kun at vise ting, der relaterer sig til en bestemt trafikkanttype.<br>
  						Dette gøres ved at tilføje enten 'car', 'bicycle' eller 'pedestrian' til iframe-koden. Hvis alle tre trafikkanttyper skal vises, tilføjes 'all'. På emner, der ikke omhandler trafikale ændringer, tilføjes 'false'.
  						<p style="margin-top: 10px;">
  							<strong>Kode eksempel på en iframet oversigt over vejarbejder der påvirker bilister i midtbyen.</strong>
  						</p>
  						<code>&lt;iframe style="height: 500px;width: 100%; border: none;" src="https://apps.odenserundt.dk/odenserundtiframe/#tag/115/<span class="pink">car</span>/55.39215271410575,10.386500358581545/13"&gt;&lt;/iframe&gt;
  						</code>
  						<p style="margin-top: 10px;">
  							<strong>Kode eksempel på en iframet oversigt over vejarbejder der påvirker cyklister i midtbyen.</strong>
  						</p>
  						<code>&lt;iframe style="height: 500px;width: 100%; border: none;" src="https://apps.odenserundt.dk/odenserundtiframe/#tag/115/<span class="pink">bicycle</span>/55.39215271410575,10.386500358581545/13"&gt;&lt;/iframe&gt;
  						</code>
  						<p style="margin-top: 10px;">
  							<strong>Kode eksempel på en iframet oversigt over vejarbejder der påvirker fodgængere i midtbyen.</strong>
  						</p>
  						<code>&lt;iframe style="height: 500px;width: 100%; border: none;" src="https://apps.odenserundt.dk/odenserundtiframe/#tag/115/<span class="pink">pedestrian</span>/55.39215271410575,10.386500358581545/13"&gt;&lt;/iframe&gt;
  						</code>
  						<p style="margin-top: 10px;">
  							<strong>Kode eksempel på en iframet oversigt over vejarbejder der påvirker alle trafikkanttyper i midtbyen.</strong>
  						</p>
  						<code >&lt;iframe style="height: 500px;width: 100%; border: none;" src="https://apps.odenserundt.dk/odenserundtiframe/#tag/115/<span class="pink">all</span>/55.39215271410575,10.386500358581545/13"&gt;&lt;/iframe&gt;
  						</code>
  					</li>
  					<li style="margin-top: 10px;"><span class="light-green">CENTERPUNKT(Valgfrit, men obligatorisk hvis der udfyldes et zoomniveau):</span> Centerpunktet for det viste kort. Udfyldes som længde- og breddegrad adskilt af et komma. Eksempel: 55.473568,10.460920<br>Koordinaterne skal adskilles af komma, og der må ikke være nogen mellemrum. Ønskede koordinater kan findes <a href="https://apps.odenserundt.dk/findkoordinater" target="_blank" class="underline blue-text"><strong>her</strong></a>.
  						Udfyldes ikke et centerpunkt, vil kortet bruge et automatisk centerpunkt, hvor alle steder vises på kortet.
  					</li>
  					<li><span class="yellow">ZOOMNIVEAU(Valgfrit):</span> Hvor langt kortet er zoomet ind fra starten. Udfyldes som en værdi mellem 10 og 18.<br> 10 er til det store overblik, hvor hele eller det meste af Fyn er synligt. 18 er til fokus på et meget lille område, feks. et bestemt stykke af en vej. Til et generelt overblik over et område anbefales 15 som zoomniveau.</li>
  					<li><strong>OBS:</strong><br>Mulighederne <strong>skal</strong> udfyldes i den viste rækkefølge.<br>
  					For at kunne udfylde en værdi, <strong>skal</strong> den forrige værdi være udfyldt.<br>
  					Du kan f.eks. ikke udfylde værdien 'centerpunkt' uden at have udfyldt 'filtrering'.<br>
  					Ønsker du ikke nogen filtrering, kan du bruge værdien 'false'.<br>
  					Det er ligeledes obligatorisk at udfylde 'centerpunkt', hvis du ønsker at sætte et zoomniveau.<br>
  					Værdien 'zoomniveau' er ikke obligatorisk at udfylde. Hvis den undlades, vil værdien 15 blive brugt som standard.
  					</li>
					</ul>

					<p><strong>Eksempel på en iframet oversigt over legepladser.</strong></p>
					<pre>
						<code>
 &lt;iframe style="height: 500px;width: 100%; border: 1px solid #565656;" src="https://apps.odenserundt.dk/odenserundtiframe/#tag/39/false"&gt;&lt;/iframe&gt;
						</code>
					</pre>

					<p>Eksemplet giver følgende resultat.</p>
					<div id="playgrounds-iframe-example">
            <iframe title="Iframe eksempel på oversigt over legepladser" style="height: 500px;width: 100%; border: 1px solid #565656;" src="https://apps.odenserundt.dk/odenserundtiframe/#tag/39"></iframe>
          </div>


					<p><strong>Eksempel på en iframet oversigt over vejarbejder der påvirker bilister i midtbyen.</strong></p>
					<pre>
						<code>
 &lt;iframe style="height: 500px;width: 100%; border: 1px solid #565656;" src="https://apps.odenserundt.dk/odenserundtiframe/#tag/115/car/55.39215271410575,10.386500358581545/13"&gt;&lt;/iframe&gt;
						</code>
					</pre>

					<p>Eksemplet giver følgende resultat.</p>
					<div id="roadwork-iframe-example">
            <iframe title="Iframe eksempel på oversigt over vejarbejder" style="height: 500px;width: 100%; border: 1px solid #565656;" src="https://apps.odenserundt.dk/odenserundtiframe/#tag/115/car/55.39215271410575,10.386500358581545/13"></iframe>
          </div>
				</div>

  		</div>
  	</div>
  </main>
</template>

<script>
export default {
  props: {
    action: {}
  },
  mounted() {
    this.$HelperFunctions.setScreenReaderFocus();
  }
}
</script>

<style lang="css" scoped>
  ul {
    list-style: initial;
    margin: initial;
    padding: 0 0 0 40px;
  }

  ul li {
    display: list-item;
  }

  pre {
    background-color: #f9f9f9;
    border: 1px solid #ddd;
  }
</style>
